import { call, put } from 'redux-saga/effects';

import {
  disableQuestionError,
  disableQuestionLoading,
  disableQuestionResponse,
  disableQuestionSuccess,
  reportQuestionError,
  reportQuestionLoading,
  reportQuestionSuccess,
} from '../actions/helpPopupsActions';
import Services from '../services';

export function* disableQuestionSagas(action) {
  // Disable necesita, studyProgramId chapterId questionId.
  try {
    yield put(disableQuestionLoading(true)); // Here we update the reducer state. (We must do this after the API call)
    const questionId = action.questionId;
    const chapterId = action.chapterId;
    const response = yield call(
      Services.HelpPopupsService.disableQuestionService,
      questionId,
      chapterId,
    );

    yield put(disableQuestionResponse(response));
    yield put(disableQuestionLoading(false));
    yield put(disableQuestionSuccess(true));
  } catch (exception) {
    // alert(exception);
    yield put(disableQuestionError(exception));
  }
}

export function* reportQuestionSagas(action) {
  try {
    yield put(reportQuestionLoading(true)); // Here we update the reducer state. (We must do this after the API call)
    const questionId = action.questionId;
    const payload = action.payload; // We need certain data to use the endpoint
    yield call(
      Services.HelpPopupsService.reportQuestionService,
      questionId,
      payload,
    );

    yield put(reportQuestionLoading(false));
    yield put(reportQuestionSuccess(true));
  } catch (exception) {
    // alert(exception);
    yield put(reportQuestionError(exception));
  }
}

export default function* sagas() {
  yield [disableQuestionSagas(), reportQuestionSagas()];
}
